import DeviceReport from "./DeviceReport";
import PageViewer from "@/components/PageViewer";
import FvuStore from "@/store/modules/fvu";
import PERMISSIONS from "@/common/permissions-lib";

const fvuProps = route => {
	return {
		fvuId: route.params.fvuId,
		deviceIdentifier: route.params.fvuId,
		deviceType: "fvu",
		rsuId: route.params.rsuId
	};
};

export default {
	path: "Verification",
	meta: {
		breadcrumb: "TFM-VU",
		authorizedRoles: [PERMISSIONS.RSU_VU_TEST_VIEW]
	},
	component: PageViewer,
	props: { pageTransition: "none" },
	children: [
		{
			path: "/",
			name: "DeviceManager.Verification",
			props: { pageTransition: "none" },
			component: () =>
				import(
					/* webpackChunkName: "DeviceManager.Verification" */ "@/views/DeviceManager/Verification/Index"
				)
		},
		DeviceReport,
		{
			path: "Replay/:testsetnum",
			name: "DeviceManager.Verification.Replay",
			props: route => {
				return { ...fvuProps(route), testsetnum: route.params.testsetnum };
			},
			meta: {
				breadcrumb() {
					return "Replay Test " + this.$route.params.testsetnum;
				}
			},
			component: () =>
				import(
					/* webpackChunkName: "DeviceManager.Verification.Replay" */ "@/views/DeviceManager/Verification/Replay"
				)
		},
		{
			path: ":fvuId",
			name: "DeviceManager.Verification.byFvuId",
			props: fvuProps,
			meta: {
				breadcrumb() {
					const fvu = this.$store.getters[
						`${FvuStore.MODULE_NAME}/byIdentifier`
					](this.$route.params.fvuId);
					return "VUnit: " + ((fvu && fvu.displayName) || "...");
				}
			},
			component: () =>
				import(
					/* webpackChunkName: "DeviceManager.Verification" */ "@/views/DeviceManager/Verification/Index"
				),
			children: [
				{
					path: "rsu/:rsuId",
					name: "DeviceManager.Verification.byFvuId.withInitialRsu",
					props: fvuProps,
					meta: {
						breadcrumb() {
							return "RSU: " + this.$route.params.rsuId;
						}
					},
					component: () =>
						import(
							/* webpackChunkName: "DeviceManager.Verification" */ "@/views/DeviceManager/Verification/Index"
						)
				}
			]
		},
		{
			path: "rsu/:rsuId",
			name: "DeviceManager.Verification.withInitialRsu",
			props: fvuProps,
			meta: {
				breadcrumb() {
					return "RSU: " + this.$route.params.rsuId;
				}
			},
			component: () =>
				import(
					/* webpackChunkName: "DeviceManager.Verification" */ "@/views/DeviceManager/Verification/Index"
				)
		}
	]
};
